/**
 * EDIリクエストの認証
 */
import * as httpConst from '../../../constants/httpConst'
import Vue from 'vue'

const API_PATH = `${httpConst.EDI_REQUEST_BASE}/api/authentications`

const ediRequestAuthentication = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    auth ({ commit }, { token }) {
      const parameter = { edi_request_token: token }
      return new Promise((resolve, reject) => {
        Vue.$http.post(API_PATH, parameter).then( data => {
          let content = data.content
          resolve(content)
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
  mutations: {},
}

export default ediRequestAuthentication
